import { Button, Form, Input } from 'antd'
import { memo, useCallback } from 'react'
import { LeagueDivision } from 'types/league-divisions'

type Props = {
    leagueDivision: LeagueDivision
    onSubmit: (leagueDivision: LeagueDivision) => void
    loading: boolean
}

export const LeagueDivisionForm = memo((props: Props) => {
    const { leagueDivision, onSubmit, loading } = props

    const onFinish = useCallback(
        (values: LeagueDivision) => {
            onSubmit(values)
        },
        [onSubmit]
    )

    return (
        <Form
            name='basic'
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            autoComplete='off'
            disabled={loading}
        >
            <Form.Item
                initialValue={leagueDivision.name}
                label='Name'
                name='name'
                rules={[{ required: true, message: 'Please input league division name!' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Button type='primary' htmlType='submit'>
                    Submit
                </Button>
                <Button htmlType={'reset'}>Reset</Button>
            </Form.Item>
        </Form>
    )
})
